import React from 'react'
import { Text, View } from 'react-native'
import { useTranslation } from 'react-i18next'
import { ReviewIssueLocationIcon, ReviewIssueUserIcon } from 'app/icons/ReviewIssueIcons'
import { DemoMaterialRequest } from 'app/models/RequestFlow'

type Props = {
  item: DemoMaterialRequest
  styles: any
}

const DemoRequestCardSections = ({ item, styles }: Props) => {
  const { t } = useTranslation()

  return (
    <>
      <View style={styles.cardDivider} />
      <View style={styles.requestSection}>
        <Text style={styles.requestSectionTitle}>{t('issue_for')}</Text>
        <View style={styles.requestSectionItem}>
          <View style={styles.requestSectionIconWrap}>
            <ReviewIssueUserIcon width={24} height={24} />
          </View>
          <View style={styles.requestSectionTextWrap}>
            <Text style={styles.requestSectionPrimaryText}>{item.farmer_name || '-'}</Text>
            <Text style={styles.requestSectionSecondaryText}>{item.farmer_mobile || '-'}</Text>
          </View>
        </View>
      </View>
      <View style={styles.requestSection}>
        <Text style={styles.requestSectionTitle}>{t('selected_dc_mdc')}</Text>
        <View style={styles.requestSectionItem}>
          <View style={styles.requestSectionIconWrap}>
            <ReviewIssueLocationIcon width={16} height={20} />
          </View>
          <View style={styles.requestSectionTextWrap}>
            <Text style={styles.requestSectionPrimaryText}>
              {item.vendor?.company_name || '-'}
            </Text>
            <Text style={styles.requestSectionSecondaryText}>
              {[item.vendor?.node?.name, item.vendor?.district?.name, item.vendor?.state?.name]
                .filter(Boolean)
                .join(', ') || '-'}
            </Text>
          </View>
        </View>
      </View>
    </>
  )
}

export default DemoRequestCardSections
